import * as React from 'react';
import useSWR from 'swr';
import { DocGrpItemId } from './PopDocGrpSett';
import { DiffLevel, DiffLevels, DocGrpDiffInfo } from './useApiDocGrp';
import { useDiffLevelCalculation } from './useDiffLevelCalculation';

export const useCompareDocGrp = (
  sels: DocGrpItemId[],
  idKoKr: number | undefined,
  idEn: number | undefined,
  idEnUs: number | undefined
): {
  diffLevel: DiffLevel;
  diffLevels: DiffLevels;
  items: DocGrpItemId[];
  koKr: DocGrpDiffInfo;
  en: DocGrpDiffInfo;
  enUs: DocGrpDiffInfo;
} => {
  /**
   * 1. 문서 그룹 차이 조회.
   * 2. 문서그룹 아이템목록 조회.
   * 3. 2개의 API가 조회되면, 각 비교항목에 대한 정보를 비교해서, 정리한 데이터를 리턴한다.
   * 예를들어, 문제의 크기를 레벨로 구분하여, 문제레벨 값을 리턴한다.
   * 4. 문서레벨 정의
   *  불일치 Different , 일부불일치 Similar, 완전일치. Same
   *  axios.get<{ docGrpItemId: DocGrpItemId }[]>('/api/member/zdata/docgrpitem/list', {params: {docGrpId: p.docGrpId}}).then(res => {
   */

  const { data: diffs } = useSWR<DocGrpDiffInfo[]>([
    '/api/member/zdata/docgrpmppng/diffsByDocIds',
    { docIds: [idKoKr, idEn, idEnUs] },
  ]);

  const { items, koKr, en, enUs } = React.useMemo<{
    items: DocGrpItemId[];
    koKr: DocGrpDiffInfo;
    en: DocGrpDiffInfo;
    enUs: DocGrpDiffInfo;
  }>(() => {
    if ((sels || []).length === 0 || !diffs) {
      return {
        items: [],
        koKr: undefined,
        en: undefined,
        enUs: undefined,
      };
    }

    const items = sels;
    const koKr = diffs.find((item) => item.lang === 'ko-KR');
    const en = diffs.find((item) => item.lang === 'en');
    const enUs = diffs.find((item) => item.lang === 'en-US');

    return {
      items,
      koKr,
      en,
      enUs,
    };
  }, [sels, diffs]);

  // Custom hook을 사용하여 diffLevel 계산
  const { diffLevel, diffLevels } = useDiffLevelCalculation(sels, diffs);

  return { diffLevel, diffLevels, items, koKr, en, enUs };
};
